var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"iframe",attrs:{"id":_vm.id,"width":_vm.width,"height":_vm.height,"src":_vm.src,"name":_vm.name,"frameborder":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }